import React from 'react'
// eslint-disable-next-line import/named
import { TFunction } from 'react-i18next'

import Box, { BoxProps } from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'

import type { Category } from '../../data/types'

type ProductCategoryProps = {
  category: Category
  // all products locales are in "navigation"
  translateFn: TFunction<'navigation'>
  onClick: () => void
} & BoxProps

export const ProductCategory = ({
  category,
  translateFn,
  onClick,
  ...restProps
}: ProductCategoryProps) => (
  <Box {...restProps}>
    <Typography variant="h7" color="primaryBrightBlueLightBg">
      {translateFn(category.tTitle)}
    </Typography>
    {category.items.map(({ tTitle, tDesc, href }) => (
      <Link href={href} onClick={onClick} key={tTitle}>
        <Flex
          flexDirection="column"
          borderLeftWidth={2}
          borderLeftColor="primaryBrightBlueLightBg"
          borderLeftStyle="solid"
          paddingLeft={2}
          marginTop={3}
          customCss={{
            '&:hover': {
              borderLeftColor: 'secondaryDarkNavy',
              //NOTE link title will change color when hovered
              '.linkTitle': {
                color: 'secondaryDarkNavy',
              },
            },
          }}
        >
          <Typography
            variant="subtitle2"
            color="primaryDeepBlack"
            className="linkTitle"
          >
            {translateFn(tTitle)}
          </Typography>
          <Typography variant="caption" color="secondaryDarkGrey">
            {translateFn(tDesc)}
          </Typography>
        </Flex>
      </Link>
    ))}
  </Box>
)
